import React from 'react'

function Popover(props) {
    const { showPopover, text } = props

    return showPopover && <div className="chat-popover">{text}</div>
}

export default Popover
